import React from "react";
import Label from "components/crm/ui/Label";
import { cx } from "components/crm/ui/uiUtils";
import { FIELD_BOX_CLASS, FIELD_GAP_CLASS } from "components/crm/ui/fieldStyles";

// Grey border, orange on focus, red on error (never thicker).
const TextField = ({
  label,
  hint,
  icon: Icon,
  error,
  helper,
  multiline,
  className,
  id,
  inputRef,
  ...props
}) => {
  const Tag_ = multiline ? "textarea" : "input";
  return (
    <div className={cx("flex flex-col", FIELD_GAP_CLASS, className)}>
      {label && (
        <Label htmlFor={id} hint={hint}>
          {label}
        </Label>
      )}
      <div
        className={cx(
          "flex items-start gap-2 transition-colors focus-within:border-primary",
          FIELD_BOX_CLASS,
          error
            ? "border-danger focus-within:border-danger"
            : "border-lineStrong"
        )}
      >
        {Icon && (
          <Icon
            size={18}
            className="mt-[1px] shrink-0 text-faint"
            strokeWidth={2}
          />
        )}
        <Tag_
          id={id}
          ref={inputRef}
          rows={multiline ? 2 : undefined}
          className="min-w-0 flex-1 resize-none bg-transparent text-sm font-normal leading-5 text-gray-900 outline-none placeholder:text-gray-400"
          {...props}
        />
      </div>
      {(error || helper) && (
        <p
          className={cx(
            "-mt-1 text-xs leading-4",
            error ? "text-danger" : "text-faint"
          )}
        >
          {error || helper}
        </p>
      )}
    </div>
  );
};

export default TextField;
